export default __webpack_public_path__ + "static/cta-bg-211348bc5625499bc2b9c6fd18f7ba83.svg";